(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jhilke-circle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduceMotion=false;
  try{reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}
  var root=document.querySelector('.jh-circle');
  if(root){
    var items=root.querySelectorAll('[data-reveal]');
    function show(item){item.classList.add('is-in');}
    var pending=[];
    for(var i=0;i<items.length;i++){pending.push(items[i]);}
    if(reduceMotion){
      for(var j=0;j<pending.length;j++){show(pending[j]);}
      pending=[];
    }else{
      var ticking=false;
      function check(){
        var edge=window.innerHeight*.92;
        var left=[];
        for(var k=0;k<pending.length;k++){
          if(pending[k].getBoundingClientRect().top<edge){show(pending[k]);}else{left.push(pending[k]);}
        }
        pending=left;
        ticking=false;
      }
      function request(){
        if(!ticking){ticking=true;requestAnimationFrame(check);}
      }
      window.addEventListener('scroll',request,{passive:true});
      window.addEventListener('resize',request,{passive:true});
      request();
    }
  }
  var hasIO='IntersectionObserver' in window;
  var sticky=document.querySelector('[data-sticky-bar]');
  if(sticky){
    var sentinel=document.querySelector('[data-sticky-sentinel]');
    var closeBtn=sticky.querySelector('[data-sticky-close]');
    var sio=null;
    function setOn(on){
      sticky.classList.toggle('is-on',on);
      sticky.setAttribute('aria-hidden',on?'false':'true');
    }
    if(sentinel&&hasIO){
      sio=new IntersectionObserver(function(entries){setOn(!entries[0].isIntersecting);},{threshold:0});
      sio.observe(sentinel);
    }
    if(closeBtn){
      closeBtn.addEventListener('click',function(){if(sio){sio.disconnect();}setOn(false);var m=document.getElementById('MainContent');if(m){if(!m.hasAttribute('tabindex'))m.setAttribute('tabindex','-1');m.focus({preventScroll:true});}});
    }
  }
  var newRange=document.querySelector('[data-est-new-range]');
  if(newRange){
    var newSalesOut=document.getElementById('jh-circle-est-new-sales');
    var amountOut=document.getElementById('jh-circle-est-amount');
    var shownAmount=50;
    var animationToken=0;
    var RATE=.10;
    function money(n){return '€'+n.toLocaleString('en-IE');}
    function fill(input,v){input.style.setProperty('--jh-fill',(v/5000*100)+'%');}
    function render(){
      var newSales=Number(newRange.value)||0;
      var target=Math.round(newSales*RATE);
      var token=++animationToken;
      if(newSalesOut){newSalesOut.textContent=money(newSales);}
      fill(newRange,newSales);
      if(amountOut){
        if(reduceMotion){shownAmount=target;amountOut.textContent=money(target);}
        else{
          var start=shownAmount;
          var startTime=null;
          function step(ts){
            if(token!==animationToken){return;}
            if(startTime===null){startTime=ts;}
            var p=Math.min((ts-startTime)/260,1);
            var eased=1-Math.pow(1-p,3);
            shownAmount=Math.round(start+(target-start)*eased);
            amountOut.textContent=money(shownAmount);
            if(p<1){requestAnimationFrame(step);}
          }
          requestAnimationFrame(step);
        }
      }
    }
    newRange.addEventListener('input',render);
    render();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jhilke-promotions"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('[data-jh-promo]');
    var C = window.JhCampaign;
    if (!root || !C || !C.config()) return;
    var cfg = C.config();
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var paused = false, lastStage = null, lastTextMinute = null;
    var $ = function (s) { return root.querySelector(s); };
    var cd = $('[data-jh-count]'), label = $('[data-jh-count-label]'), digits = $('.jh-bf__digits'), textEl = $('[data-jh-count-text]');
    var secCell = $('[data-jh-seccell]'), pauseBtn = $('[data-jh-pause]');
    var nd = $('[data-jh-d]'), nh = $('[data-jh-h]'), nm = $('[data-jh-m]'), ns = $('[data-jh-s]');
    var DAY = 86400000;
    if (reduce) { secCell.hidden = true; digits.classList.add('no-seconds'); }

    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
    function show(sel, on) { root.querySelectorAll(sel).forEach(function (el) { el.hidden = !on; }); }

    // shown: before | public | final (last 24 hours) | ended
    function setStage(shown) {
      root.querySelectorAll('[data-jh-state]').forEach(function (el) { el.hidden = el.getAttribute('data-jh-state') !== shown; });
      var ended = shown === 'ended', before = shown === 'before';
      cd.hidden = ended;
      show('[data-jh-bigwrap]', !ended);
      show('[data-jh-endedtitle]', ended);
      show('#jh-bf-steps', !ended);
      show('[data-jh-gift]', !ended);
      show('[data-jh-how]', !ended);
      show('[data-jh-join]', before || ended);
      show('[data-jh-cta-join]', before || ended);
      show('[data-jh-cta-shop]', !(before || ended));
      var ss = $('[data-jh-shopsub]');
      if (ss) ss.textContent = ended ? 'Every print at its usual price.' : before ? 'Every print is at its usual price. The amount off comes off your order at checkout once the sale opens.' : 'Every print is at its usual price. The amount off comes off your order at checkout.';
      var lead = $('[data-jh-lead]');
      if (ended) {
        lead.setAttribute('data-jh-ended', ''); lead.textContent = lead.getAttribute('data-jh-ended-lead') || 'Join the list and we will write to you before the next one.';
        var t = $('[data-jh-join-title]'); if (t) t.textContent = 'Hear about the next sale first';
        var sub = $('[data-jh-join-sub]'); if (sub) sub.textContent = 'Join the Glint List and we write to you before our next sale.';
        var j = $('[data-jh-cta-join]'); if (j) j.textContent = 'Join the list';
      }
      label.textContent = before ? 'The sale opens in' : 'The sale closes in';
      lastTextMinute = null;
    }

    function setTheme(shown) {
      var cm = (shown === 'public' || shown === 'final') && C.now() >= C.ms('cyber') && C.now() < C.ms('cyber_end');
      root.setAttribute('data-theme', cm ? 'cm' : 'bf');
      show('[data-jh-cmtag]', cm && shown === 'public');
    }

    function tick(force) {
      var stage = C.stage();
      var before = stage === 'before' || stage === 'presale';
      var shown = stage === 'ended' ? 'ended' : before ? 'before' : (C.ms('close') - C.now() <= DAY ? 'final' : 'public');
      if (shown !== lastStage) { lastStage = shown; setStage(shown); }
      setTheme(shown);
      syncBar();
      if (shown === 'ended') return;
      var target = before ? C.startMs() : C.ms('close');
      var secs = Math.floor(Math.max(0, target - C.now()) / 1000);
      var d = Math.floor(secs / 86400), h = Math.floor((secs % 86400) / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
      // 2026-10-28 (JB): calmer clock. Seconds show only in the last 24 hours before the opening or the close (and never under reduced motion).
      var showSec = !reduce && secs <= 86400;
      secCell.hidden = !showSec; digits.classList.toggle('no-seconds', !showSec);
      if (!paused || force) { nd.textContent = String(d); nh.textContent = pad(h); nm.textContent = pad(m); ns.textContent = pad(s); }
      var minuteKey = Math.floor(secs / 60);
      if (minuteKey !== lastTextMinute) {
        lastTextMinute = minuteKey;
        var parts = [];
        if (d) parts.push(plural(d, 'day'));
        if (d || h) parts.push(plural(h, 'hour'));
        parts.push(plural(m, 'minute'));
        textEl.textContent = (before ? 'The sale opens in ' : 'The sale closes in ') + parts.join(', ').replace(/, ([^,]*)$/, ' and $1') + '.';
      }
    }

    pauseBtn.addEventListener('click', function () {
      paused = !paused;
      pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pauseBtn.textContent = paused ? 'Start the moving numbers again' : 'Pause the moving numbers';
      if (!paused) tick(true);
    });
    tick(true);
    setInterval(function () { if (!document.hidden) tick(); }, reduce ? 15000 : 1000);

    // ---- phone bar: shown only in the sale states, and only while the hero button is off screen ----
    var bar = $('[data-jh-sticky]'), heroBtn = $('[data-jh-cta-shop]'), heroOn = true;
    function syncBar() {
      if (!bar) return;
      var live = lastStage === 'public' || lastStage === 'final';
      var cb = document.getElementById('shopify-pc__banner');
      var banner = !!(cb && cb.offsetHeight > 0 && getComputedStyle(cb).display !== 'none');
      var on = live && !heroOn && !banner;
      bar.hidden = !live;
      bar.toggleAttribute('data-off', !on);
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    if (bar && heroBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { heroOn = e[0].isIntersecting; syncBar(); }).observe(heroBtn);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(true); });
    // the cookie banner is added and removed by Shopify: syncBar runs on every clock tick (setInterval below), so the bar steps aside within a second and never covers its buttons
    // ---- sign-up (same list and public key as snippets/jhilke-signup-popup.liquid) ----
    var form = $('[data-jh-promo-form]'), errEl = $('[data-jh-promo-error]'), okEl = $('[data-jh-promo-success]'), btn = $('[data-jh-promo-submit]');
    form.hidden = false; // without scripts the form stays hidden, so it never posts back to the page
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var email = (input.value || '').trim();
      if (!email || !input.checkValidity()) {
        errEl.textContent = email ? 'That email does not look right. Check it and try again.' : 'Enter your email address to join the list.';
        errEl.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      errEl.hidden = true;
      btn.disabled = true;
      btn.textContent = 'Joining…';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VVP83g', {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: cfg.source,
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: 'T9wacH' } } }
          }
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('bad status');
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          try { Shopify.analytics.publish('jhilke:sign_up', { placement: 'promotions' }); } catch (x) {}
        }
        var stage = C.stage();
        okEl.textContent = (stage === 'ended')
          ? 'You are on the list. We will write to you before our next sale.'
          : 'You are on the list. We will email you before the sale opens.';
        form.hidden = true;
        okEl.hidden = false;
        try { okEl.focus({ preventScroll: true }); } catch (x) {}
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
        errEl.textContent = 'Something went wrong. Please try again.';
        errEl.hidden = false;
      });
    });
  }
  // deferred scripts (the campaign clock) finish before DOMContentLoaded; this bundle may run first
  if (document.readyState === 'complete') init(); else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jhilke-sales-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('[data-jh-hub]');
    var C = window.JhCampaign;
    if (!root || !C || !C.config()) return;
    var cfg = C.config();
    var revealMs = Date.parse(root.getAttribute('data-reveal') || '');
    function phase() { var st = C.stage(); if (st === 'public') return 'live'; if (st === 'ended') return 'between'; return (isFinite(revealMs) && C.now() < revealMs) ? 'teaser' : 'before'; }
    function setState(shown) {
      root.querySelectorAll('[data-jh-hub-state]').forEach(function (el) { el.hidden = (' ' + el.getAttribute('data-jh-hub-state') + ' ').indexOf(' ' + shown + ' ') < 0; });
      var lab = root.querySelector('[data-jh-hub-count-label]'); if (lab) lab.textContent = shown === 'live' ? 'The sale closes in' : 'The sale opens in';
      lastMinute = null;
      root.querySelectorAll('[data-jh-hub-join]').forEach(function (el) { el.hidden = shown === 'live' || shown === 'between'; }); // no sale: the footer's own Glint List is the one sign-up
      root.querySelectorAll('[data-jh-hub-past]').forEach(function (el) { el.hidden = shown !== 'between'; });
      root.setAttribute('data-first-state', shown);
    }
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var paused = false, lastMinute = null, last = null;
    var $ = function (s) { return root.querySelector(s); };
    var nd = $('[data-jh-hub-d]'), nh = $('[data-jh-hub-h]'), nm = $('[data-jh-hub-m]'), ns = $('[data-jh-hub-s]');
    var secCell = $('[data-jh-hub-seccell]'), textEl = $('[data-jh-hub-count-text]'), pauseBtn = $('[data-jh-hub-pause]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
    function clock(force) {
      if (!nd) return; // the sale blocks are not on a teaser or no-sale page
      var stage = C.stage();
      if (stage === 'ended') return;
      var before = stage !== 'public';
      var target = before ? C.startMs() : C.ms('close');
      var secs = Math.floor(Math.max(0, target - C.now()) / 1000);
      var d = Math.floor(secs / 86400), h = Math.floor((secs % 86400) / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
      secCell.hidden = reduce || secs > 86400; // calmer clock: seconds only in the last 24 hours
      if (!paused || force) { nd.textContent = String(d); nh.textContent = pad(h); nm.textContent = pad(m); ns.textContent = pad(s); }
      var key = Math.floor(secs / 60);
      if (key !== lastMinute) {
        lastMinute = key;
        var parts = [];
        if (d) parts.push(plural(d, 'day'));
        if (d || h) parts.push(plural(h, 'hour'));
        parts.push(plural(m, 'minute'));
        textEl.textContent = (before ? 'The sale opens in ' : 'The sale closes in ') + parts.join(', ').replace(/, ([^,]*)$/, ' and $1') + '.';
      }
    }
    function need(shown) { return root.querySelector({ teaser: '.jh-sh__teaser', before: '.jh-sh__hero', live: '.jh-sh__hero', between: '.jh-sh__top' }[shown]); }
    function tick(force) {
      var s = phase();
      if (s !== last) {
        last = s; setState(s);
        // a cached page printed an earlier state: reload once so the server prints this one (sessionStorage guards against a loop)
        if (!need(s)) { try { if (sessionStorage.getItem('jh-hub-reload') !== s) { sessionStorage.setItem('jh-hub-reload', s); location.reload(); return; } } catch (e) {} }
      }
      clock(force);
    }
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pauseBtn.textContent = paused ? 'Start the moving numbers again' : 'Pause the moving numbers';
      if (!paused) clock(true);
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(true); });
    tick(true); setInterval(function () { if (!document.hidden) tick(); }, reduce ? 15000 : 1000);
    document.addEventListener('jh-campaign:stage', function () { tick(true); });

    var form = root.querySelector('[data-jh-hub-form]'), errEl = root.querySelector('[data-jh-hub-error]'), okEl = root.querySelector('[data-jh-hub-success]'), btn = root.querySelector('[data-jh-hub-submit]');
    form.hidden = false; // without scripts the form stays hidden, so it never posts back to the page
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var email = (input.value || '').trim();
      if (!email || !input.checkValidity()) {
        errEl.textContent = email ? 'That email does not look right. Check it and try again.' : 'Enter your email address to join the list.';
        errEl.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); return;
      }
      input.removeAttribute('aria-invalid'); errEl.hidden = true; btn.disabled = true; btn.textContent = 'Joining…';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VVP83g', {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: cfg.source, profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: 'T9wacH' } } } } })
      }).then(function (r) {
        if (!r.ok) throw new Error('bad status');
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) { try { Shopify.analytics.publish('jhilke:sign_up', { placement: 'promotions' }); } catch (x) {} }
        okEl.textContent = C.stage() === 'ended' ? 'You are on the list. We will write to you before our next sale.' : 'You are on the list. We will email you before the sale opens.';
        form.hidden = true; okEl.hidden = false;
        try { okEl.focus({ preventScroll: true }); } catch (x) {}
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Try again';
        errEl.textContent = 'Something went wrong. Please try again.'; errEl.hidden = false;
      });
    });
  }
  if (document.readyState === 'complete') init(); else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
